import * as React from 'react';

import {ActionBox} from 'shells/action-box/action-box';
import {ErrorIcon, SuccessIcon} from 'shells/action-box/action-icons';

import {MAX_CHARACTERS, MIN_CHARACTERS} from '../../sms/consts';

import {SmsEditionActionElement} from './sms-edition-action-element';

type Props = {
    htmlUrlPath: string;
    content: string;
};

export function CharacterCountActionBox(props: Props) {
    const isMessageWithinLimit =
        props.content.length <= MAX_CHARACTERS && props.content.length >= MIN_CHARACTERS;

    let subtitle = `Between ${MIN_CHARACTERS} and ${MAX_CHARACTERS} characters`;
    if (props.content.length > MAX_CHARACTERS) {
        subtitle = `Your message is over ${MAX_CHARACTERS} characters`;
    }
    if (props.content.length < MIN_CHARACTERS) {
        subtitle = `Your message is under ${MIN_CHARACTERS} characters`;
    }

    const icon = isMessageWithinLimit ? <SuccessIcon /> : <ErrorIcon />;

    return (
        <ActionBox
            title='Character count'
            subtitle={subtitle}
            icon={icon}
            actionElement={
                !isMessageWithinLimit ? (
                    <SmsEditionActionElement htmlUrlPath={props.htmlUrlPath} text='Edit message' />
                ) : undefined
            }
        />
    );
}
